import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";
import Helper from "util/Helper";

/**
 * Address book — patient's alternate contact numbers. Wraps the shared
 * `/patients/{pid}/pan` endpoints already deployed and consumed by
 * bridge-frontend. Two operations only: list + add. Edit / delete are
 * intentionally omitted (bridge exposes them via a different flow; this
 * dialog is add-first).
 */
class AddressBookService {
  constructor() {
    this.apiService = new APIService();
    // Side effect: installs String.prototype.format for the URL templates.
    this.helper = new Helper();
  }

  /**
   * GET → alternates array. Empty list is a legitimate state (patient
   * hasn't added any yet), not an error.
   */
  list(patientId, onResponse, onError) {
    const url = APIConfig.addressBook.list.format(patientId);
    return this.apiService.get(
      url,
      (res) => onResponse(Array.isArray(res) ? res : []),
      onError,
    );
  }

  /**
   * Add an alternate. Body matches bridge's `addNumber` payload verbatim
   * so the two apps stay consistent:
   *   {patientId, countryCode:int, areaCode:"", alternateNumber, type:"mobile", description}
   */
  add(patientId, body, onResponse, onError) {
    const url = APIConfig.addressBook.add.format(patientId);
    return this.apiService.post(url, body, onResponse, onError);
  }

  /**
   * Update an alternate. Body carries the alternate's `id` alongside
   * the mutable fields — matches the shape bridge PUTs:
   *   {id, patientId, type, alternateNumber, countryCode, areaCode, description}
   */
  update(patientId, id, body, onResponse, onError) {
    const url = APIConfig.addressBook.update.format(patientId, id);
    return this.apiService.put(url, body, onResponse, onError);
  }
}

export default AddressBookService;
